module.exports = __webpack_public_path__ + "img/nova-front-angle.22dadcfa.png";